var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "md-dialog",
    {
      staticClass: "filter-dialog",
      attrs: { "md-active": _vm.show },
      on: {
        "update:mdActive": function ($event) {
          _vm.show = $event
        },
        "update:md-active": function ($event) {
          _vm.show = $event
        },
        "hide-dialog": function ($event) {
          _vm.show = false
        },
        "show-save-dialog": _vm.showSaveDialog,
        "show-delete-dialog": function ($event) {
          return _vm.showDeleteDialog($event)
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }